<template>
  <button v-if="isVisible" type="button" id="topBtn" @click.stop="scrollToTop" :style="topBtnStyle"></button>
</template>

<script setup lang="ts">

const isVisible = ref(false);
const opacity = ref(0);

const topBtnStyle = computed(() => {
  return {
    display: isVisible.value ? "block" : "none",
    opacity: opacity.value
  };
});

const handleScroll = () => {
  const currentScrollY = window.scrollY;
  if (currentScrollY > 100 && !isVisible.value) fadeIn();
  if (currentScrollY <= 100 && isVisible.value) fadeOut();
};

const fadeIn = () => {
  opacity.value = 0;
  isVisible.value = true;
  const fadeInInterval = setInterval(() => {
    if (opacity.value < 1) opacity.value += 0.05;
    else clearInterval(fadeInInterval);
  }, 30);
};

const fadeOut = () => {
  const fadeOutInterval = setInterval(() => {
    if (opacity.value > 0) opacity.value -= 0.05;
    else {
      clearInterval(fadeOutInterval);
      isVisible.value = false;
    }
  }, 30);
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>